import { getProvidersData } from '../../helpers/data-helper';

export default {
	data: function() {
		return {
			rating: [],
			filter: {
				price: '',
				home_type: [],
				user_type: [],
				installation_type: '',
				features: []
			},
			features: [],
			show_reset: false
		}
	},
	watch: {
		filter: {
			handler(new_val, old_val) {
				let empty = true;
				for (var key in this.filter) {
					if (this.filter[key].length && empty) {
						empty = false;
					}
				}
				console.log("empty", empty);
				this.show_reset = !empty;
			},
			deep: true
		}
	},
	mounted: function() {
		this.features = [
			{
				title: '24/7 Monitoring',
				value: '24-7-monitoring'
			},
			{
				title: 'Pet Friendly',
				value: 'pet-friendly'
			},
			{
				title: 'No Contract',
				value: 'no-contract'
			},
			{
				title: 'Video Storage',
				value: 'video-storage'
			},
			{
				title: 'Mobile Access',
				value: 'mobile-access'
			},
			{
				title: 'Remote Control',
				value: 'remote-access'
			}
		]

		analytics.page({type: 'page', name: 'Compare', path: 'Compare'}, {integrations: {'AdWords': false}});
	},
	methods: {
		setUserType: function(type) {
			this.filter.user_type = type;
		},
		setHomeType: function(type) {
			this.filter.home_type = type;
		},
		setInstallationType: function(type) {
			this.filter.installation_type = type;
		},
		setFeatures: function(feature) {
			let index = this.filter.features.indexOf(feature);
			if (index > -1) {
				this.filter.features.splice(index, 1);
			} else {
				this.filters.features.push(feature);
			}
		},
		isFeatureSelected: function(feature) {
			return this.filter.features.indexOf(feature) > -1; 
		},
		resetFilters: function() {
			this.filter = {
				price: '',
				home_type: [],
				user_type: [],
				installation_type: '',
				features: []
			}
			this.show_reset = false;
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/Compare/compare.js